var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_2223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.576 27.6299C20.3171 31.2255 24.8608 34 28.5761 34C30.2459 34 31.7088 33.4401 32.8867 32.196C33.5728 31.4619 34 30.6034 34 29.7574C34 29.1353 33.754 28.5381 33.1455 28.1151L29.1715 25.4027C28.5631 25.0046 28.0582 24.8056 27.5922 24.8056C27.0096 24.8056 26.4789 25.1291 25.8834 25.689L24.9644 26.5598C24.8219 26.6968 24.6407 26.7589 24.4725 26.7589C24.2783 26.7589 24.0841 26.6843 23.9546 26.6221C23.1521 26.2115 21.7799 25.0793 20.4984 23.86C19.2298 22.6407 18.0518 21.3219 17.6375 20.5505C17.5728 20.4137 17.4951 20.2395 17.4951 20.0529C17.4951 19.8911 17.5469 19.7294 17.6893 19.5925L18.6084 18.6843C19.178 18.112 19.5275 17.6143 19.5275 17.042C19.5275 16.5941 19.3074 16.1089 18.8802 15.5241L16.0971 11.7543C15.644 11.1571 15.0097 10.8958 14.3107 10.8958C13.4563 10.8958 12.576 11.269 11.8123 11.9782C10.5566 13.1353 10 14.5661 10 16.1462C10 19.7169 12.8349 24.0467 16.576 27.6299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_2223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.fd24e9ab1bf7743a47fcc4be4f3cae62.svg";
export { ForwardRef as ReactComponent };